(function () {
  if (window.cartAddonsInitialized) return;
  window.cartAddonsInitialized = true;

  console.log("Cart Addons Script Initialized");

  let isUpdating = false;

  function getCart() {
    return fetch(window.Shopify.routes.root + 'cart.js').then(res => res.json());
  }

  function setCheckoutState(disabled) {
    document.querySelectorAll('[name="checkout"]').forEach(btn => {
      btn.disabled = disabled;
      if (disabled) {
        btn.style.opacity = '0.5';
        btn.style.cursor = 'not-allowed';
      } else {
        btn.style.opacity = '1';
        btn.style.cursor = 'pointer';
      }
    });
  }

  function recalculateAddons() {
    if (isUpdating) return;
    const config = window.cartAddonsConfig;
    if (!config || !config.signatureId) return;

    // Run this initially to guarantee safe state
    setCheckoutState(true);

    const insCbs = document.querySelectorAll('[data-addon-checkbox="insurance"]');
    const sigCbs = document.querySelectorAll('[data-addon-checkbox="signature"]');

    const isInsChecked = Array.from(insCbs).some(cb => cb.checked);
    const isSigChecked = Array.from(sigCbs).some(cb => cb.checked);

    getCart().then(cart => {
      let totalWithoutInsurance = cart.total_price;
      let standardItemCount = 0;

      let hasSignature = false;
      let signatureQty = 0;
      let hasInsuranceFree = false;
      let insuranceFreeQty = 0;
      let hasInsuranceFixed = false;
      let insuranceFixedQty = 0;

      cart.items.forEach(item => {
        if (item.variant_id == config.signatureId) {
          hasSignature = true;
          signatureQty = item.quantity;
          totalWithoutInsurance -= item.final_line_price;
        }
        else if (item.variant_id == config.insuranceFreeId) {
          hasInsuranceFree = true;
          insuranceFreeQty = item.quantity;
        }
        else if (item.variant_id == config.insuranceFixedId) {
          hasInsuranceFixed = true;
          insuranceFixedQty = item.quantity;
          totalWithoutInsurance -= item.final_line_price;
        } else {
          standardItemCount += item.quantity;
        }
      });

      let expectedInsuranceId = config.insuranceFreeId;
      let expectedInsuranceQty = 1;

      if (totalWithoutInsurance > 10000) {
        expectedInsuranceId = config.insuranceFixedId;
        expectedInsuranceQty = Math.ceil((totalWithoutInsurance - 10000) / 10000);
      }

      console.log(`Cart Addons: Total without addons = $${(totalWithoutInsurance / 100).toFixed(2)}`);

      let expectedInsurancePrice = expectedInsuranceId === config.insuranceFixedId ? (2.50 * expectedInsuranceQty) : 0;
      if (insCbs.length > 0) {
        console.log(`Cart Addons: check the check box Shipping Insurance is = ${isInsChecked ? 'True' : 'False'}`);
        if (isInsChecked && standardItemCount > 0) {
          console.log(`Cart Addons: Apply total shipping price = ${expectedInsurancePrice}`);
        }
      }

      let itemsToAdd = [];
      let updates = {};
      let needsUpdate = false;

      const isCartInvalid = standardItemCount === 0 || totalWithoutInsurance > 500000;

      // Handle the absolute empty cart boundary or disabled > $5000
      if (isCartInvalid) {
        insCbs.forEach(cb => { cb.checked = false; cb.disabled = true; });
        sigCbs.forEach(cb => { cb.checked = false; cb.disabled = true; });
        if (hasSignature && signatureQty !== 0) { updates[config.signatureId] = 0; needsUpdate = true; }
        if (hasInsuranceFree && insuranceFreeQty !== 0) { updates[config.insuranceFreeId] = 0; needsUpdate = true; }
        if (hasInsuranceFixed && insuranceFixedQty !== 0) { updates[config.insuranceFixedId] = 0; needsUpdate = true; }
      } else {
        insCbs.forEach(cb => cb.disabled = false);
        sigCbs.forEach(cb => cb.disabled = false);
        
        // Standard behavior handling checkboxes syncing logic internally
        if (sigCbs.length > 0) {
          if (isSigChecked && signatureQty !== 1) {
            if (!hasSignature) itemsToAdd.push({ id: config.signatureId, quantity: 1 });
            else updates[config.signatureId] = 1;
            needsUpdate = true;
          } else if (!isSigChecked && signatureQty !== 0) {
            updates[config.signatureId] = 0;
            needsUpdate = true;
          }
        }

        if (insCbs.length > 0) {
          if (isInsChecked) {
            if (expectedInsuranceId == config.insuranceFreeId) {
              if (!hasInsuranceFree || insuranceFreeQty !== 1) {
                if (!hasInsuranceFree) itemsToAdd.push({ id: config.insuranceFreeId, quantity: 1 });
                else updates[config.insuranceFreeId] = 1;
                needsUpdate = true;
              }
              if (hasInsuranceFixed) {
                updates[config.insuranceFixedId] = 0;
                needsUpdate = true;
              }
            } else {
              if (!hasInsuranceFixed || insuranceFixedQty !== expectedInsuranceQty) {
                if (!hasInsuranceFixed) itemsToAdd.push({ id: config.insuranceFixedId, quantity: expectedInsuranceQty });
                else updates[config.insuranceFixedId] = expectedInsuranceQty;
                needsUpdate = true;
              }
              if (hasInsuranceFree) {
                updates[config.insuranceFreeId] = 0;
                needsUpdate = true;
              }
            }
          } else {
            if (hasInsuranceFree && insuranceFreeQty !== 0) {
              updates[config.insuranceFreeId] = 0;
              needsUpdate = true;
            }
            if (hasInsuranceFixed && insuranceFixedQty !== 0) {
              updates[config.insuranceFixedId] = 0;
              needsUpdate = true;
            }
          }
        }
      }

      if (needsUpdate) {
        console.log("Cart Addons: Corrections required:", { addToCart: itemsToAdd, updateCart: updates });
        isUpdating = true;

        insCbs.forEach(cb => cb.disabled = true);
        sigCbs.forEach(cb => cb.disabled = true);

        // Perform additions first, then updates
        let promiseChain = Promise.resolve();

        if (itemsToAdd.length > 0) {
          promiseChain = promiseChain.then(() => {
            return fetch(window.Shopify.routes.root + 'cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ items: itemsToAdd })
            });
          });
        }

        if (Object.keys(updates).length > 0) {
          promiseChain = promiseChain.then(() => {
            return fetch(window.Shopify.routes.root + 'cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ updates: updates })
            });
          });
        }

        promiseChain
          .then(() => {
            console.log("Cart Addons: Successfully corrected backend cart. Fetching UI updates...");
            let fetchUrl = window.location.pathname + '?section_id=mini_cart';
            if (window.location.pathname.includes('/cart')) {
              fetchUrl = window.location.pathname; // Fetch full page to get both drawer and main-cart subtotals
            }
            return fetch(fetchUrl);
          })
          .then(res => res.text())
          .then(html => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');

            const newTotalPrices = doc.querySelectorAll('.t4s-cart-total, .t4s-cart__ttprice, .t4s-summary-cart, .t4s-cartPage__footer');
            const currentTotalPrices = document.querySelectorAll('.t4s-cart-total, .t4s-cart__ttprice, .t4s-summary-cart, .t4s-cartPage__footer');

            if (newTotalPrices.length > 0 && currentTotalPrices.length > 0) {
              currentTotalPrices.forEach((el, index) => {
                if (newTotalPrices[index]) el.innerHTML = newTotalPrices[index].innerHTML;
              });
            }

            const newCounts = doc.querySelectorAll('.t4s-cart-count, .t4s-count-box');
            const currentCounts = document.querySelectorAll('.t4s-cart-count, .t4s-count-box');
            if (newCounts.length > 0 && currentCounts.length > 0) {
              currentCounts.forEach((el, index) => {
                if (newCounts[index]) el.innerHTML = newCounts[index].innerHTML;
              });
            }


            // Asynchronously structurally purge dropped addon wrappers from the DOM prior to form submissions to prevent index overhang
            if (updates[config.signatureId] === 0) document.querySelectorAll(`.is-t4s-addon-item[data-variant-id="${config.signatureId}"]`).forEach(n => n.remove());
            if (updates[config.insuranceFreeId] === 0) document.querySelectorAll(`.is-t4s-addon-item[data-variant-id="${config.insuranceFreeId}"]`).forEach(n => n.remove());
            if (updates[config.insuranceFixedId] === 0) document.querySelectorAll(`.is-t4s-addon-item[data-variant-id="${config.insuranceFixedId}"]`).forEach(n => n.remove());

            if (!isCartInvalid) {
              insCbs.forEach(cb => cb.disabled = false);
              sigCbs.forEach(cb => cb.disabled = false);
            }
          })
          .catch(error => {
            console.error("Cart Addons Error: ", error);
            if (!isCartInvalid) {
              insCbs.forEach(cb => cb.disabled = false);
              sigCbs.forEach(cb => cb.disabled = false);
            }
          })
          .finally(() => {
            setTimeout(() => {
              isUpdating = false;
              setCheckoutState(false);
            }, 500);
          });
      } else {
        setCheckoutState(false);
      }
    });
  }

  document.addEventListener('change', function (e) {
    if (e.target.dataset.addonCheckbox === 'insurance') {
      document.querySelectorAll('[data-addon-checkbox="insurance"]').forEach(cb => cb.checked = e.target.checked);
      recalculateAddons();
    }
    if (e.target.dataset.addonCheckbox === 'signature') {
      document.querySelectorAll('[data-addon-checkbox="signature"]').forEach(cb => cb.checked = e.target.checked);
      recalculateAddons();
    }
  });

  // Intercept all fetch requests globally to hook perfectly into theme's AJAX cart
  const originalFetch = window.fetch;
  window.fetch = async function () {
    const url = arguments[0];
    const options = arguments[1] || {};
    const method = (options.method || 'GET').toUpperCase();
    
    const isCartReq = typeof url === 'string' && (
      url.includes('/cart/update') || 
      url.includes('/cart/change') || 
      url.includes('/cart/add') || 
      url.includes('/cart/clear') ||
      (method === 'POST' && url.includes('/cart'))
    );

    if (isCartReq) setCheckoutState(true);

    const response = await originalFetch.apply(this, arguments);

    if (isCartReq && !isUpdating) {
      clearTimeout(window.cartAddonsTimeout);
      window.cartAddonsTimeout = setTimeout(recalculateAddons, 600);
    }
    return response;
  };

  // Intercept all XHR requests globally
  const originalXhrOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    const reqMethod = (method || 'GET').toUpperCase();
    const isCartReq = typeof url === 'string' && (
      url.includes('/cart/update') || 
      url.includes('/cart/change') || 
      url.includes('/cart/add') || 
      url.includes('/cart/clear') ||
      (reqMethod === 'POST' && url.includes('/cart'))
    );

    if (isCartReq) setCheckoutState(true);

    this.addEventListener('load', function () {
      if (isCartReq && !isUpdating) {
        clearTimeout(window.cartAddonsTimeout);
        window.cartAddonsTimeout = setTimeout(recalculateAddons, 600);
      }
    });
    originalXhrOpen.apply(this, arguments);
  };

  setTimeout(recalculateAddons, 500);

  // Pre-flight Checkout Form Validation
  // Intercepts the naive form submission, calculates exact future subtotal from synchronous DOM quantities,
  // structurally updates the concealed addons inline, and lets the form elegantly continue straight to checkout.
  document.addEventListener('submit', function(e) {
    if (e.target && e.target.tagName === 'FORM' && e.target.action && e.target.action.includes('/cart')) {
      const form = e.target;
      let totalItemsPrice = 0;
      const config = window.cartAddonsConfig;
      if (!config) return;

      const sigInput = form.querySelector(`.is-t4s-addon-item[data-variant-id="${config.signatureId}"] input.t4s-quantity-input`);
      const insInput = form.querySelector(`.is-t4s-addon-item[data-variant-id="${config.insuranceFreeId}"] input.t4s-quantity-input`);
      const insFixedInput = form.querySelector(`.is-t4s-addon-item[data-variant-id="${config.insuranceFixedId}"] input.t4s-quantity-input`);

      const chkSig = document.getElementById('cart_page_signature_addon') || document.querySelector('[data-addon-checkbox="signature"]');
      const chkIns = document.querySelector('[data-addon-checkbox="insurance"]');
      
      form.querySelectorAll('input.t4s-quantity-input').forEach(input => {
         const wrapper = input.closest('.is-t4s-addon-item');
         if (!wrapper) { 
             const price = parseInt(input.getAttribute('data-price') || 0);
             const qty = parseInt(input.value || 0);
             totalItemsPrice += (price * qty);
         }
      });
      
      const totalDollars = totalItemsPrice / 100;
      
      let reqSig = 0;
      let reqInsFree = 0;
      let reqInsFixed = 0;

      if (totalDollars <= 5000) {
          if (chkSig && chkSig.checked) reqSig = 1;
          
          if (chkIns && chkIns.checked && totalDollars > 0) {
              if (totalDollars <= 100) {
                  reqInsFree = 1;
              } else {
                  const extraAmount = totalDollars - 100;
                  reqInsFixed = Math.ceil(extraAmount / 100);
              }
          }
      }

      let needsAjaxAdd = false;
      if (reqSig > 0 && !sigInput) needsAjaxAdd = true;
      if (reqInsFree > 0 && !insInput) needsAjaxAdd = true;
      if (reqInsFixed > 0 && !insFixedInput) needsAjaxAdd = true;

      // Unsafe to natively submit via DOM because Shopify /cart form POST cannot dynamically Add missing items,
      // or because a background update is mid-flight. We seize the checkout flow robustly.
      if (needsAjaxAdd || isUpdating) {
          e.preventDefault();
          const btn = form.querySelector('[name="checkout"], [type="submit"]');
          if (btn) {
              btn.innerHTML = 'Updating...';
              btn.style.opacity = '0.5';
              btn.style.pointerEvents = 'none';
          }
          
          recalculateAddons();

          let checkInterval = setInterval(() => {
              if (!isUpdating) {
                  clearInterval(checkInterval);
                  window.location.href = '/checkout';
              }
          }, 100);
          return;
      }

      // Perfectly safe to synchronously patch the DOM inputs and let native checkout navigation continue!
      if (sigInput) sigInput.value = reqSig;
      if (insInput) insInput.value = reqInsFree;
      if (insFixedInput) insFixedInput.value = reqInsFixed;
    }
  });

})();


